// opervex-frontend/src/routes/systemRoutes.js

import AccessProfile from "../pages/System/AccessProfile";
import Setting from "../pages/System/Setting";
import OperationGM from "../pages/System/OperationGoodsMovement";
import User from "../pages/System/User";
import Template from "../pages/System/Template";

const systemRoutes = [
  // User
  { path: "System/User", private: true, component: <User />, role: "USER_SYSTEM" },
  { path: "System/User/:id", private: true, component: <User />, role: "USER_SYSTEM" },

  // Profile
  { path: "System/AccessProfile", private: true, component: <AccessProfile />, role: "USER_PROFILE" },
  { path: "System/AccessProfile/:id", private: true, component: <AccessProfile />, role: "USER_PROFILE" },

  // Template
  { path: "System/Template", private: true, component: <Template />, role: "TEMPLATES" },
  { path: "System/Template/:id", private: true, component: <Template />, role: "TEMPLATES" },

  // Operation Goods Movement
  { path: "System/OperationGoodsMovement", private: true, component: <OperationGM />, role: "OPERATION_GM" },

  // Configuration
  { path: "System/Setting", private: true, component: <Setting />, role: "SYSTEM", admin: true },
];

export default systemRoutes;
